"use client";
import Link from "next/link";
import { Button, Icon } from "@chakra-ui/react";
import { GoArrowRight } from "@onemind-services-llc/react-icons-ng/go";
import { MAIN_ROUTES } from "@/constants/routes";

const ContactUsButton = () => {
  return (
    <Button
      as={Link}
      bg={"#007FFF"}
      borderColor="#4299e1"
      borderWidth={"1px"}
      fontSize={"lg"}
      color={"white"}
      href={MAIN_ROUTES.CONTACT_US}
      minW={"160px"}
      minH={"45px"}
      _hover={{ backgroundColor: "#0056B3" }}
    >
      Need help? Contact us <Icon as={GoArrowRight} ml={2} />
    </Button>
  );
};

export default ContactUsButton;
